<script>
  import currency from 'currency.js';
  import ToggleVisibilityLink from './ToggleVisibilityLink.svelte';

  export let Charges;
  export let TotalNights;
  export let Total;

  let isHidden = true;
</script>

<ToggleVisibilityLink
  label={'Estimated price'}
  elementId="availability-fees"
  hidden={isHidden}>
  <hr class="width-full border-top border-dashed border-0 my-1" />
  <table
    class="availability-fees f5 poppins-font py-2 width-full lh-condensed text-left">
    <caption class="h4 poppins-bold-font text-left">Summary of fees</caption>
    {#each Charges as { Description, Amount }}
      <tr class="border-0">
        <th class="d-table-cell poppins-font py-1 text-normal v-align-top"
          >{Description}</th>
        <td
          class="d-table-cell text-right v-align-top py-1 poppins-font pr-0"
          >{currency(Amount).format()}</td>
      </tr>
    {/each}
  </table>
</ToggleVisibilityLink>
<hr class="width-full border-top border-dashed border-0 my-1" />
<table
  class="availability-fees mb-3 lh-condensed width-full"
  data-testid="availability-fees-total">
  <tr class="border-0">
    <th class="d-table-cell poppins-bold-font v-align-top text-normal text-left"
      >Total
      {#if TotalNights >= 1}
        <span data-testid="availability-total-night"
          >({TotalNights} {TotalNights > 1 ? 'nights' : 'night'})
        </span>
      {/if}
    </th>
    <td class="d-table-cell text-right v-align-top poppins-font pr-0"
      ><span class="poppins-bold-font">{currency(Total).format()}</span>
    </td>
  </tr>
</table>

<style>
  .availability-fees {
    :global(th),
    :global(td) {
      font-size: 16px;
    }
  }
</style>
